import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getColumnWidth',
})
export class GetColumnWidthPipe implements PipeTransform {
  transform(eventsCount: number, cellWidth: number): number {
    return eventsCount > 2 ? eventsCount * (cellWidth / 2) : cellWidth;
  }
}
